require('./bootstrap');
require('./plugins');

import { createApp } from 'vue';
import feather from 'feather-icons';

import { createRouter, createWebHistory } from 'vue-router';
import LoginPage from "./components/LoginPage.vue";

import ProjectsList from "./components/Projects/ProjectsList.vue";
import CreateProject from "./components/Projects/CreateProject.vue";

import CompaniesList from "./components/Companies/CompaniesList.vue";
import CreateCompany from "./components/Companies/CreateCompany.vue";

import UsersList from "./components/Users/UsersList.vue";
import WorkHours from "./components/Users/WorkHours.vue";

import CalendarView from "./components/View/CalendarView.vue";
import WorkCalendarTable from "./components/WorkCalendar/WorkCalendarTable.vue";

import TendersList from "./components/Tenders/TendersList.vue";

import NotificationManager from './NotificationManager';

const authId = '#auth';
const pageBodyAppId = '#page_body_app';

const notificationManager = new NotificationManager();
let notify = notificationManager.createNotify();

notificationManager.updateNotify(notify);

const router = createRouter({
    history: createWebHistory(),
    routes: [
        { path: '/login', component: LoginPage },
        { path: '/projects/list', component: ProjectsList },
        { path: '/projects/create', component: CreateProject },
        { path: '/companies/list', component: CompaniesList },
        { path: '/companies/create', component: CreateCompany },
        { path: '/users/list', component: UsersList },
        { path: '/users/work-hours', component: WorkHours },
        { path: '/tenders/list', component: TendersList },
    ],
    linkExactActiveClass: 'active',
});

function initializeVueApp(selector, components) {
    if ($(selector).length > 0) {
        createApp({ components })
            .use(router)
            .mount(selector)
            .$nextTick(() => {
                feather.replace();
            });
    }
}

initializeVueApp(authId, { LoginPage });
initializeVueApp(pageBodyAppId, {
    ProjectsList,
    CreateProject,
    CompaniesList,
    CreateCompany,
    UsersList,
    CalendarView,
    WorkCalendarTable,
    WorkHours,
    TendersList,
});

$(document).on("shown.bs.modal", (e) => {
    const body = $("body");
    //console.log("shown.bs.modal triggered: ", $(".modal.show").length);
    if (!body.hasClass("modal-open")) {
        body.addClass("modal-open");
    }
});

$(document).on("hidden.bs.modal", (e) => {
    //console.log("hidden.bs.modal triggered: ", $(".modal.show").length);

    // Bootstrap removes modal-open before the hidden event fires. The fix:
    setTimeout(() => {
        if ($(".modal.show").length > 0) {
            $("body").addClass("modal-open"); // Restore modal-open if there are windows
        } else {
            $("body").removeClass("modal-open"); // Remove modal-open if no more windows are available
        }
    }, 10); // The delay is needed to let Bootstrap complete its processing
});
